import React from "react";

const SkipNav = ({ linkToMain, children, className, ...rest }) => {
  return (
    <a
      href={linkToMain || "#main-content"}
      className={`${className || ""}`}
      {...rest}
    >
      {children}
    </a>
  );
};

export default SkipNav;
